import { render, staticRenderFns } from "./CreditPurpose.vue?vue&type=template&id=6a534600&scoped=true&"
import script from "./CreditPurpose.vue?vue&type=script&lang=js&"
export * from "./CreditPurpose.vue?vue&type=script&lang=js&"
import style0 from "./CreditPurpose.vue?vue&type=style&index=0&id=6a534600&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a534600",
  null
  
)

export default component.exports